import { IApplicationState } from 'shared/map-search/types/redux';

export const selectIsDrawingMode = (state: IApplicationState) => state.drawing.isDrawingMode;
